import mongoose from 'mongoose';
import schema, { IServiceHeartDocument } from '../schemas/service-heart';

const ServiceHeart = (mongoose.models.ServiceHeart ||
  mongoose.model<IServiceHeartDocument>('ServiceHeart', schema)) as mongoose.Model<
  IServiceHeartDocument
>;

export default ServiceHeart;
